<div class="not-found-container">
  <h1>You are not a Training Provider</h1>
  <p>You need to be a training provider to use this app.</p>
</div>

